import "./Einhorn.css";

import * as React from "react";

export default class Einhorn extends React.PureComponent {

    public render() {
        return (
            <div className="Einhorn">

                <img src={"assets/lyrics/einhorn.gif"} />

                <div className="Einhorn__musicPlayer">
                    <audio controls={true} preload="auto">
                        <source src={"assets/music/einhorn.mp3"} />
                    </audio>
                </div>

                <div className="Einhorn__disclaimer">
                    Wir positionieren uns klar für ein menschliches Miteinander, Toleranz und
                    Akzeptanz und gegen Diskriminierung und Ausgrenzung auf Grundlage der
                    Herkunft, der Religion, der sexuellen Orientierung und Identität.
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Lyrics/Einhorn.tsx